export const Experiences = [
    {
        title: "Application Support Analyst",
        employer: "Town of Canmore",
        from: "Feb, 2020",
        to: "Present",
        details: [
            "Creation of process and business requirements documents for the migration of each Department documents from the G: drive to SharePoint.",
            "Design of SharePoint sites and subsites in accordance with Departmental requirements and in line with record management practices for the Town, ensuring that all libraries are setup for easy use operationally.",
            "Migration of all documents from G: drive to SharePoint 2016 using ShareGate and also mapping of documents to appropriate content types.",
            "Conduct SharePoint training for staff upon migration and as part of on-boarding process to the Company.",
            "Conversion of paper forms, pdf forms and processes to better optimized and automated electronic forms using Nintex forms and workflows."
        ]
    },
    {
        title: "IT Support/Developer",
        employer: "Adoniaa Inc.",
        from: "Dec, 2018",
        to: "Jan, 2020",
        details: [
            "Creation of process and business requirements documents for the daily running of the store.",
            "Training of new staff on the use of the software application (MindBody) for Customer Relationship Management and Inventory Management.",
            "Provision of technical support on the usage and optimization of inventory software.",
            "Integration of payment gateway into the company website to enable clients book appointments and buy memberships.",
            "Deployment of software solutions into Company website.",
            "Interaction with software vendor for issue referral and resolution.",
            "Interaction with client to make appointment bookings and respond to all business enquiries."
        ]
    },
    {
        title: "SharePoint Developer",
        employer: "Intels Nig Ltd.",
        from: "Nov, 2015",
        to: "Nov, 2018",
        details: [
            "Assisted in the customization, configuration, testing and deployment of custom SharePoint solutions using SharePoint lists, documents and tasks.",
            "Customized SharePoint 2013 webparts using JavaScript, HTML, CSS to extend the front-end features on SharePoint.",
            "PAssisted with creation and administration of SharePoint 2010 sites.",
            "Managed user access, site securities and security groups.",
            "Configured service applications and integrated SharePoint with external data.",
            "Designed SharePoint workflows using SharePoint designer to implement customized approval processes on documents, lists and to link documents to tasks.",
            "Responsible for overall farm health, monitoring server utilization, backups and restore sites and farms, documentation, reviews and updates of farm architecture.",
            "Conducted trainings for SharePoint users upon implementation of new software solutions.",
            "Liaison with internal and external project stakeholders during SharePoint project planning and design phase for efficient capturing and documentation of Business requirements."
        ]
    }
]